import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    selectedItem: ['dashboard'],
    drawerOpen: false,
    drawerManagement: false
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.selectedItem = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },

        openDrawerManagement(state, action) {
            state.drawerManagement = action.payload;
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer, openDrawerManagement } = menu.actions;
